import { useEffect } from "react";
import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";

// Reusable scroll-triggered animation wrapper
export function AnimateOnScroll({ children, delay = 0, className = "" }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-60px" });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 40 }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

// Section label component
export function SectionLabel({ text }) {
  return (
    <span className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">
      {text}
    </span>
  );
}

// Section heading
export function SectionHeading({ children }) {
  return (
    <h2 className="font-heading text-3xl md:text-4xl tracking-tight font-bold text-white">
      {children}
    </h2>
  );
}

// Scroll to top on route change
export function ScrollToTop() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}
